import { Component, OnInit, ViewChild, OnChanges, AfterViewInit, OnDestroy } from "@angular/core";
import { BaseChartDirective } from "ng2-charts";
import { DatePipe } from "@angular/common";
import { APIURL } from "app/Shared/Constant/API_Urls";
import { UrlsService } from "app/Shared/Services/urls.service";
import { UserService } from "app/Shared/Services/user.service";
import { SharedHttpClientService } from "app/Shared/Services/shared-http-client.service";
import { EmitterService } from "app/Shared/Services/emitter.service";
import { Subscription } from "rxjs";
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from "@angular/material/tooltip";
import { ChartConfiguration } from "chart.js";

@Component({
    selector: 'app-cat-transaction-error-graph',
    imports: [MatTooltipModule, BaseChartDirective, MatProgressSpinnerModule],
    templateUrl: './cat-transaction-error-graph.component.html',
    styleUrls: ['./cat-transaction-error-graph.component.scss']
})
export class CatTransactionErrorGraphComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  isLoadingResults!: boolean;
  windowsize: any;
  currentHover = "Cat";
  windowY: any;
  windowX: any;
  slidecount!: number;
  @ViewChild(BaseChartDirective) chart: BaseChartDirective | any;
  JsonData: Object | any;
  Totalcount!: number;
  TotalcountIntial!:number;
  public dateLabelsArray: any = [];

  private Fcat: any[] = [];
  private Lcat: any[] = [];

  public tempdate: any;
  public subscription: Subscription | any;
  public barChartOptions: any = {
    scaleShowVerticalLines: false,
    responsive: true,
    scaleShowValues: true,
    scaleValuePaddingX: 0,
    scaleValuePaddingY: 0,

    scales: {
      y:{
        //scaleLabel:{ display: true, labelString: 'Exception Count'},
        ticks: {
          beginAtZero: true,
          maxTicksLimit: 5,
          stepSize: 1,
          // Create Numberic notation labels
          callback: function (value:any, index:any, values:any) {

            if (value >= 1000 && value < 1000000) {
              value = value / 1000 + ' K';
            }
            if (value >= 1000000) {
              value = value / 1000000 + ' M';
            }
            return value;
          }
        }
      },
      x: {
        scrollbar: {
          enabled: true
        }
      }
    },
    tooltips: {
      enabled: true,
      backgroundColor: 'Black',
      textColor: 'black',
      opacity: 1
    },
    animations: {
      tension: {
        duration: 100,
        easing: 'linear',
        from: 1,
        to: 0,
        loop: true
      }
    },
    plugins: {
      colors: {
        enabled: true
      },
      datalabels: { 
       display: false
      },
    },
  };

  public barChartLabels: any[] = this.dateLabelsArray;
  public barChartType: string = 'bar';
  //public barChartLegend: boolean = true;
  public chartColors: any[] = [
    { backgroundColor: "green" },
    { backgroundColor: "#0288D1" }];
  public barChartData: any[] = [
    {
      data: [0, 0, 0, 0, 0, 0, 0], label: 'RSMS Identified',categoryPercentage: 0.7,
      barPercentage: 0.5,backgroundColor: "#008000"
    },
    {
      data: [0, 0, 0, 0, 0, 0, 0], label: 'Open',categoryPercentage: 0.7,
      barPercentage: 0.5,backgroundColor: "#0288d1"
    }
  ];
  LastCATExecutionDate: any;
  private interval:number = 0;
  private leftCounter: number = 0;
  private isRequestCompleted:boolean=true;

  public chartData: ChartConfiguration<'bar'>['data'] = {
    labels: this.barChartLabels,
    datasets: this.barChartData
  }

  constructor(
    private UrlsService: UrlsService,
    private datePipe: DatePipe,
    private UserService: UserService,
    private SharedHttpClientService: SharedHttpClientService,
    private EmitterService: EmitterService) {
    this.LastCATExecutionDate = null;
  }

  ngOnInit() {
    this.LastCATExecutionDate = this.UserService.getyyyyMMddDateFormate(this.UserService.CATDashboard_LastExecutionDate);
    if (this.LastCATExecutionDate) {
      this.getData();
      this.subscription = this.EmitterService.reloadMainDashBoard.subscribe(value => {
        if (value) {
          this.isLoadingResults = true;
          this.UserService.get_CAT_Last_ReportDate().subscribe((res: any) => {
            let response: any = res;
            let jsondata = response.data[0]
            if(jsondata) {
              this.LastCATExecutionDate = jsondata.CATLastExcecutionReportDate !=="" ? this.UserService.getFormatedDate(jsondata.CATLastExcecutionReportDate) : new Date();
              this.LastCATExecutionDate = this.UserService.getyyyyMMddDateFormate(this.LastCATExecutionDate);
              this.getData();
            }
          });
        }
      });
    }
  }

  ngAfterViewInit() {
    this.sortData();
  }

  ngOnChanges() {
    this.chartData= {
      labels: this.barChartLabels,
      datasets: this.barChartData
    }
  }

  getData() {
    this.isLoadingResults = true;
    if(this.isRequestCompleted){
      this.isRequestCompleted = false;
    let days:string = this.UserService.getDays() + this.interval;
          this.SharedHttpClientService.post(
          this.UrlsService.setAPIURl(
            APIURL.CAT_Dash_Bar_Graph_PreValidation
            ), {
              "mpid": this.UserService.getActiveMPID(),
              "days": days.toString()
          })
      .subscribe({
        next: (data:any) => {
          this.isRequestCompleted = true;
          this.isLoadingResults = false;
          let dataset: any = data;
          this.JsonData = dataset.Data;
          if (this.JsonData == null) {
            this.JsonData = [
              { fcatopen: 0, reportDate: "No-Data", lcatopen: 0 },
              { fcatopen: 0, reportDate: "No-Data", lcatopen: 0 },
              { fcatopen: 0, reportDate: "No-Data", lcatopen: 0 },
              { fcatopen: 0, reportDate: "No-Data", lcatopen: 0 },
              { fcatopen: 0, reportDate: "No-Data", lcatopen: 0 },
              { fcatopen: 0, reportDate: "No-Data", lcatopen: 0 }
            ];
            this.Totalcount = Object.keys(this.JsonData).length;
            this.TotalcountIntial = this.Totalcount;
          }
          else {
            let previousTotal = this.Totalcount;
            this.Totalcount = Object.keys(this.JsonData).length;
            this.TotalcountIntial = this.Totalcount;
            
            this.slidecount = 0;
            if (this.Totalcount <= 5) {
              this.windowsize = 0;
              for (let i = 0, t = 0; i < this.Totalcount; i++ , t++) {
                this.dateLabelsArray.push(this.datePipe.transform(this.JsonData[i].reportDate, 'dd-MMM'));
                this.Fcat[t] = ( this.JsonData[i].fcatopen);
                this.Lcat[t] = ( this.JsonData[i].lcatopen);
              }
            } else {
              this.windowsize = 5;
              if (this.leftCounter < 6) {
                this.windowY = this.Totalcount + this.slidecount;
                this.windowX = (this.windowY - this.windowsize);
  
              } else {
                this.windowX = this.windowX + (Object.keys(this.JsonData).length - previousTotal);
                this.windowY = this.windowX + 5;
              }
              this.sortData();
            }
          }
        },
        error: (e) => {
          console.error(e);
          this.isLoadingResults = false;
        }
      });
    }
    this.CatException();
  }

  clickLeft() {
    this.slidecount = -1;
    this.leftCounter++;
    if ((this.leftCounter%15!=0) && this.windowX!=10) {
      this.windowY = this.windowY + this.slidecount;
      this.windowX = (this.windowY - this.windowsize);
      this.sortData();
    }
  }

  clickRight() {
    this.slidecount = 1;
    if (this.windowY <= this.TotalcountIntial && this.windowsize >= 5) {
      this.windowY = this.windowY + this.slidecount;
      this.windowX = (this.windowY - this.windowsize);
      this.Totalcount += 1;
      this.sortData();
    }
  }

  sortData() {
    if ((this.windowY < this.Totalcount || this.leftCounter == 0) && this.windowY > 0) {
      if((this.leftCounter != 0 && this.leftCounter%15 == 0) || this.windowX==10){
        this.interval += 30;
        this.leftCounter++;
        this.getData();
      }
      this.dateLabelsArray.splice(0, this.dateLabelsArray.length);
      this.Fcat.splice(0, this.Fcat.length);
      this.Lcat.splice(0, this.Lcat.length);

      for (let i = this.windowX, t = 0; i < this.windowY; i++ , t++) {
        if(this.JsonData[i] != undefined){
        this.dateLabelsArray.push(this.datePipe.transform(this.JsonData[i].reportDate, 'dd-MMM'));
        this.Fcat[t] = ( this.JsonData[i].fcatopen);
        this.Lcat[t] = ( this.JsonData[i].lcatopen);
      }
      }
    }    
    this.windowY >= this.Totalcount;
    this.CatException();
  }


  // events
  public chartClicked(e: any): void {
    let date: any = "NULL";
    let ChartElement;
    if (e.active.length > 0) {
      ChartElement = e.active[0]
      if (ChartElement) {
        date = this.dateLabelsArray[ChartElement.index];
        e.active[0].view.backgroundColor = "green";
        e.active[0].model.backgroundColor = "green";
        e.active[1].view.backgroundColor = "green";
        e.active[1].model.backgroundColor = "green";
        e.active[1].chart.ctx.backgroundColor = "green";

        const chart0 = e.active[0].chart;
        const chart1 = e.active[1].chart;
        const activePoints = chart0.getElementAtEvent(e.event);
        if (activePoints.length > 0) {
          // get the internal index of slice in pie chart
          const clickedElementIndex = activePoints[0].index;

          const label = chart0.data.labels[clickedElementIndex];
          // get value by index
          const value = chart0.data.datasets[0].data[clickedElementIndex];

        }
      }
      this.chartData= {
        labels: this.barChartLabels,
        datasets: this.barChartData
      }
    }

  }
  CatException(): any {
    this.barChartData = [
      {
        data: this.Lcat,
        label: 'Open',
        backgroundColor:'#008000'
      },
      {
        data: this.Fcat,
        label: 'RSMS Identified',
        backgroundColor:'#0288d1'
      }
    ];
   this.chartData= {
      labels: this.barChartLabels,
      datasets: this.barChartData
    }
  }
  public chartHovered(e: any): void {
  }

  ngOnDestroy() {
    if(this.subscription)
    this.subscription.unsubscribe();
  }

}
